import { gql, useLazyQuery } from '@apollo/client';

export const FIND_JOB_LOCATION = gql`
  query findJobLocation($searchParams: FindJobLocationInput!) {
    findJobLocation(searchParams: $searchParams) {
      _id
      jobId
      companyLocationId
      companyBusinessAddressId
      companyDepartmentId
      jobSupervisors {
        _id
        supervisorJobTitle
        supervisorMemberId
        supervisorMember {
          profile {
            displayName
          }
        }
      }
    }
  }
`;

export const useLazyFindJobLocation = () => {
  const [query, { data, loading }] = useLazyQuery(FIND_JOB_LOCATION, { fetchPolicy: 'no-cache' });

  return {
    query,
    jobLocation: data?.findJobLocation || {},
    loading,
  };
};
